{
  "journalAudit.action.org.agent.draft_deleted": "Organisation agent draft deleted"
}
